(ns teamoesterreich.admin-mode.data.trainingMember
  (:require [clojure.walk]
            [goog.json :as json]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.ajax :as ajax]
            [teamoesterreich.util.download :as h-download]
            [teamoesterreich.util.log :as log]))





(defn >member-save [uuid data done-fn]
  (ajax/auth-put> (backend/get-auth) (str backend/BASE_URL "/training-member/" uuid)
                  (ajax/serialize data)
                  (fn [r-list status]
                    (log/debug ">training->member-save done" r-list status)
                    (if (= status 200)
                      (done-fn (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                      (done-fn {:error (str "Fehler: Datensatz konnte nicht angelegt werden! " status)}
                               )))))

(defn >members-set [event-uuid member-uuids action slot-uuid done-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/training-event/" event-uuid "/members-action?action=" action "&slot-uuid=" slot-uuid)
                   (ajax/serialize member-uuids)
                   (fn [r-list status]
                     (log/debug "d-trainingMember/>members-set " (count member-uuids) " done" r-list status)
                     (if (= status 200)
                       (done-fn)
                       (done-fn {:error (str "Fehler: Aktion konnte nicht durchgeführt werden! " status)}
                                )))))


(defn >member-invite [member-uuid done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/training-member/" member-uuid "/invite")
                  (fn [r-list status]
                    (log/debug ">training->member-invite done" r-list status)
                    (if (< status 400)
                      (done-fn)
                      (done-fn {:error (str "Fehler: Datensatz konnte nicht angelegt werden! " status)}
                               )))))

(defn >member-drop [uuid done-fn]
  (ajax/auth-delete> (backend/get-auth) (str backend/BASE_URL "/training-member/" uuid)
                     (fn [r-list status]
                       (log/debug ">training->member-drop done" r-list status)
                       (if (< status 400)
                         (done-fn)
                         (done-fn {:error (str "Fehler: Datensatz konnte nicht angelegt werden! " status)}
                                  )))))


(defn open-csv [trainingEvent-uuid filter-response filter-mission filter-slots]
  (h-download/open-download-url (backend/get-auth) (str "/download/training-members/" trainingEvent-uuid "?filter-response=" filter-response "&filter-mission=" filter-mission )))













